module.exports = __webpack_public_path__ + "static/media/S1-6-Bauzz-cod6.bfc8a342.png";